/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Time range enum matching frontend TimeRange type
 */
export enum TimeRange {

    _1d = '1d',

    _7d = '7d',

    _30d = '30d',

    _90d = '90d',

    Ytd = 'ytd',

    All = 'all'
}
